export const enumBanner = {
  web_Homepage_Top: 'Web_Homepage_Top',
  web_AgreementProduct_Top_Banner: 'Web_AgreementProduct_Top_Banner',
  web_ManageBrand_Top_Banner: 'Web_ManageBrand_Top_Banner'
};
export const enumTopic = {
  MROWebsiteServiceAgreement: 'MROWebsiteServiceAgreement',
  MROWebsitePrivacyPolicy: 'MROWebsitePrivacyPolicy'
};
export const enumFooter = [
  {
    title: '操作指南',
    List: [
      {
        name: '网站服务协议',
        key: 'MROWebsiteServiceAgreement'
      },
      {
        name: '基本操作指南',
        key: 'BasicOperationGuide'
      },
      {
        name: '如何询价',
        key: 'HowToInquire'
      }, {
        name: '如何订购',
        key: 'HowToOrder'
      }
    ]
  },
  {
    title: '付款须知',
    List: [
      {
        name: '如何支付',
        key: 'HowToPay'
      },
      {
        name: '开票信息',
        key: 'BillingInformation'
      }
    ]
  },
  {
    title: '售后服务',
    List: [
      {
        name: '配送方式',
        key: 'DeliveryMethod'
      }, {
        name: '交货及相关政策',
        key: 'DeliveryAndRelatedPolicies'
      }, {
        name: '投诉受理',
        key: 'ComplaintAcceptance'
      }
    ]
  }, {
    title: '内容中心',
    List: [
      //  {
      //   name: '公司介绍',
      //   key: 'CompanyIntroductionAndServiceIntroduction'
      // },
      {
        name: '产品选型指南',
        key: 'ProductSelectionGuide'
      }, {
        name: '行业解决方案',
        key: 'IndustrySolutions'
      }, {
        name: '行业报告',
        key: 'IndustryReports'
      }]
  },
  {
    title: '关于鼎阳',
    List: [{
      name: '公司简介',
      key: 'CompanyProfile'
    }, {
      name: '联系我们',
      key: 'ContactUs'
    }, {
      name: '商务服务',
      key: 'BusinessServices'
    }, {
      name: '友情链接',
      key: 'Links'
    }]
  }
];
export const enumAboutMenu = [
  {
    name: '关于鼎阳',
    iconClass: 'icon-guanyuourcompany',
    key: 'AboutOurCompany'
  },
  {
    name: '鼎阳模式与案例',
    iconClass: 'icon-ourcompanymoshiyuanli',
    key: 'OurCompanyModelAndCase'
  },
  {
    name: '鼎阳组织体系',
    iconClass: 'icon-ourcompanyzuzhitixi',
    key: 'OurCompanyOrganizationSystem'
  },
  {
    name: '社会责任',
    iconClass: 'icon-shehuizeren',
    key: 'SocialResponsibility'
  },
  {
    name: '鼎阳公益',
    iconClass: 'icon-ourcompanygongyi',
    key: 'OurCompanyPublicWelfare'
  },
  {
    name: '服务网络',
    iconClass: 'icon-fuwuwangzhan',
    key: 'ServiceNetwork'
  },
  {
    name: '物流体系',
    iconClass: 'icon-wuliutixi',
    key: 'LogisticsSystem'
  },
  {
    name: '加入鼎阳',
    iconClass: 'icon-jiaruourcompany',
    key: 'JoinOurCompany',
    redirectUrl: 'http://portal.dingyang.com/jobs'
  },
  {
    name: '工作在鼎阳',
    iconClass: 'icon-gongzuozaiourcompany',
    key: 'WorkInOurCompany'
  },
  {
    name: '鼎阳动态',
    iconClass: 'icon-ourcompanydongtai',
    key: 'ourcompanyNews'
  }];

export const skfSsoUrls = {
  auth: 'auth/realms/app/protocol/openid-connect/auth',
  appid: '1180154'
};



// WEBPACK FOOTER //
// ./src/utils/enum.js